<template>
  <div class="wrapper">
    <dashboard-bar refreshButton />
    <div class="wrapp">
      <div class="row">
        <div class="col-lg-3" refreshButton>
          <span class="header-icon">
            <font-awesome-icon :icon="['fas', 'th-large']" />
          </span>
          <div style="display: flex;">
          <h2>{{ $t('answers.categorization') }}</h2>
          <font-awesome-icon
            id="info-categorization"
            :icon="['fas', 'info-circle']"
            style="font-size: 15px; color: #c1c1c1; margin-left: 10px; margin-top: 5px;"
          />
          </div>
          <b-popover
            target="info-categorization"
            triggers="hover"
            placement="top"
          >
            <p>A categorização é feita por resposta. Por exemplo, uma resposta contém 3 campos do tipo input, então primeiro será categorizado esses três campos desta única resposta.
            Após terminado de categorizar, irá para a proxima resposta.</p>

            <p>Obs1: Caso não categorize alguma pergunta do tipo input daquela resposta, após entrar na página novamente, aquela resposta irá cair novamente até que categorize todas as perguntas do tipo input.</p>
            <p>Obs2: Por padrão traz somente as perguntas do tipo INPUT que contém comentário.</p>
            <p>Obs3: Cai primeiro a resposta mais recente para categorizar.</p>
          </b-popover>
        </div>

        <div class="col-12 header-filters mt-4">
          <div class="filters-area">
            <div class="search-answers">
              <input
                type="text"
                class="form-control"
                id="input-answer"
                :placeholder="$t('answers.searchInput')"
                v-model="filter"
                @keyup="searchByFilter"
              />
              <button @click="cleanFilter" class="btn btn-outline-primary">
                {{ $t('answers.searchButton') }}
              </button>
            </div>

            <div class="filters-options-area">
              <div class="ml-3 p-0">
                <b-form-select
                  @change="handleFilter"
                  v-model="filterSelected"
                  :options="filterOptions"
                ></b-form-select>
              </div>
              <div v-if="displayFilterOptions" class="ml-3 p-0">
                <b-form-select
                  @change="handleFilterValue"
                  v-model="filterValueSelected"
                  :options="filterSelectedOptions"
                ></b-form-select>
              </div>
              <div
                v-if="
                  filterSelected === 'category' && filterValueSelected !== null
                "
                class="ml-3 p-0"
              >
                <b-form-select
                  @change="handleFilterSubCategory"
                  v-model="filterSubCategorySelected"
                  :options="filterOptionsSubCategory"
                ></b-form-select>
              </div>
              <div
                v-if="
                  filterSelected === 'treatmentTags' &&
                  filterValueSelected !== null
                "
                class="ml-3 p-0"
              >
                <b-form-select
                  @change="handleFilterSubTag"
                  v-model="filterSubTagSelected"
                  :options="filterOptionsSubTag"
                ></b-form-select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12 filters-area">
          <div v-if="this.profileSelect.value" class="tag">
            <span>
              {{ $t('answers.filterOptions.profile') }}:
              {{ this.profileSelect.text }}
            </span>
            <span @click="removeFilter('profile')" class="remove">&times;</span>
          </div>
          <div v-if="this.statusSelect.value" class="tag">
            <span>
              {{ $t('answers.filterOptions.status') }}:
              {{ this.statusSelect.text }}
            </span>
            <span @click="removeFilter('status')" class="remove">&times;</span>
          </div>
          <div v-if="this.categorySelected.value" class="tag">
            <span>
              {{ $t('answers.filterOptions.category') }}:
              {{ this.categorySelected.text }}
            </span>
            <span @click="removeFilter('category')" class="remove"
              >&times;</span
            >
          </div>
          <div v-if="this.notificationSelected.value" class="tag">
            <span>
              {{ $t('answers.filterOptions.notification') }}:
              {{ this.notificationSelected.text }}
            </span>
            <span @click="removeFilter('notification')" class="remove">
              &times;
            </span>
          </div>
          <div v-if="this.channelSelected.value" class="tag">
            <span>
              {{ $t('answers.filterOptions.channel') }}:
              {{ this.channelSelected.text }}
            </span>
            <span @click="removeFilter('channel')" class="remove">
              &times;
            </span>
          </div>
          <div v-if="this.subCategorySelected.value" class="tag">
            <span>
              SubCategoria:
              {{ this.subCategorySelected.text }}
            </span>
            <span @click="removeFilter('subCategory')" class="remove"
              >&times;</span
            >
          </div>
          <div v-if="this.responsibleSelected.value" class="tag">
            <span>
              {{ $t('answers.filterOptions.responsible') }}:
              {{ this.responsibleSelected.text }}
            </span>
            <span @click="removeFilter('responsible')" class="remove"
              >&times;</span
            >
          </div>
          <div v-if="this.commentSelected.value" class="tag">
            <span>
              {{ $t('answers.filterOptions.comments') }}:
              {{ this.commentSelected.text }}
            </span>
            <span @click="removeFilter('comment')" class="remove">
              &times;
            </span>
          </div>
          <div v-if="this.anonymousSelected.value" class="tag">
            <span>
              {{ this.$t('answers.filterOptions.anonymous') }}:
              {{ this.anonymousSelected.text }}
            </span>
            <span @click="removeFilter('anonymous')" class="remove">
              &times;
            </span>
          </div>
          <div v-if="this.tagSelected.value" class="tag">
            <span>
              Tag:
              {{ this.tagSelected.text }}
            </span>
            <span @click="removeFilter('tag')" class="remove"> &times; </span>
          </div>
          <div v-if="subTagSelected.value" class="tag">
            <span>
              SubTag:
              {{ subTagSelected.text }}
            </span>
            <span @click="removeFilter('subTag')" class="remove">&times;</span>
          </div>
        </div>
      </div>

      <div
        class="row"
        v-if="
          allAnswers &&
          allAnswers.answers &&
          allAnswers.answers.length > 0 &&
          !this.$store.state.treatments.loading
        "
      >
        <div
          class="col-4 content"
          style="border-right: 1px solid #d9d9d9; padding: 0; height: 450px"
        >
          <label class="title">{{ $t('answers.infoAnswer') }}</label>
          <div class="row">
            <div class="col p-2">
              <div class="row">
                <div class="col-1 p-0 ml-4 mr-2">
                  <span>{{ $t('answers.gradeAnswer') }}</span>
                  <template
                    v-if="
                      allAnswers.answers[indexAnswer].metric === 'like-dislike'
                    "
                  >
                    <p v-if="allAnswers.answers[indexAnswer].review === 1">
                      <img
                        alt="Like"
                        width="40"
                        height="40"
                        src="../../../assets/Like.svg"
                      />
                    </p>
                    <p v-if="allAnswers.answers[indexAnswer].review === 0">
                      <img
                        alt="Like"
                        width="40"
                        height="40"
                        src="../../../assets/Deslike.svg"
                      />
                    </p>
                  </template>
                  <template v-else>
                    <div
                      :class="`flag-grade flag-grade-${gradeFormat(
                        allAnswers.answers[indexAnswer].review,
                      )}`"
                    >
                      <span
                        v-if="allAnswers.answers[indexAnswer].review != '99'"
                        >{{ allAnswers.answers[indexAnswer].review }}</span
                      >
                    </div>
                  </template>
                </div>
                <div class="col-2 ml-3 p-0 mt-1">
                  <p class="info-data-title">ID:</p>
                  <p class="info-data-title">{{ $t('answers.nameAnswer') }}:</p>
                  <p class="info-data-title">
                    {{ $t('answers.emailAnswer') }}:
                  </p>
                  <p class="info-data-title">
                    {{ $t('answers.phoneAnswer') }}:
                  </p>
                  <p class="info-data-title">
                    {{ $t('answers.channelAnswer') }}:
                  </p>
                  <p class="info-data-title">
                    {{ $t('answers.actionAnswer') }}:
                  </p>
                  <p class="info-data-title">
                    {{ $t('answers.metricAnswer') }}:
                  </p>
                </div>
                <div class="col p-0 mt-1">
                  <p class="info-data">
                    {{ allAnswers.answers[indexAnswer].controlId }}
                  </p>
                  <p class="info-data">
                    {{
                      checkName(
                        allAnswers.answers[indexAnswer].anonymousResponse,
                        allAnswers.answers[indexAnswer].name,
                      )
                    }}
                  </p>
                  <p class="info-data">
                    {{
                      checkUserData(
                        allAnswers.answers[indexAnswer].anonymousResponse,
                        userProfile.permissions.answers.anonymous_profile,
                        allAnswers.answers[indexAnswer].email,
                      )
                    }}
                  </p>
                  <p class="info-data">
                    {{
                      checkUserData(
                        allAnswers.answers[indexAnswer].anonymousResponse,
                        userProfile.permissions.answers.anonymous_profile,
                        allAnswers.answers[indexAnswer].phone,
                      )
                    }}
                  </p>
                  <p class="info-data">
                    {{ allAnswers.answers[indexAnswer].channel }}
                  </p>
                  <p class="info-data">
                    {{ allAnswers.answers[indexAnswer].actionId.name }}
                  </p>
                  <p class="info-data">
                    {{ allAnswers.answers[indexAnswer].metric }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-8">
          <div class="content-question">
            <div class="position">
              <img
                id="arrow-left"
                style="cursor: pointer"
                v-if="indexAnswer !== 0"
                @click="beforeAnswer()"
                src="../../../assets/polygon-left.png"
              />
            </div>
            <div class="info-question">
              <center>Questão {{ indexAnswer + 1 }}</center>
              <p class="paragraph">
                <span class="question">Pergunta:</span>
                {{ allAnswers.answers[indexAnswer].textQuestion }}
              </p>

              <div class="row">
                <div class="col-6">
                  <label class="title-name">Feedback</label>
                  <div class="feedback-info">
                    {{ allAnswers.answers[indexAnswer].answerQuestion }}
                  </div>
                </div>
                <div class="col-6">
                  <label class="title-name">Categoria</label>

                  <div class="category-box" id="category">
                    <div class="align-input">
                      <input
                        class="input-search-categories"
                        v-model="categorySearch"
                      />
                      <button
                        class="btn btn-outline-primary icon-eraser-category"
                        @click="categorySearch = ''"
                      >
                        <i title="Limpar" class="fas fa-eraser"></i>
                      </button>
                    </div>

                    <div v-if="listCategories.length !== 0">
                      <b-dropdown-text>
                        <ul
                          v-for="(option, i) in categoriesList"
                          :key="i"
                          style="font-size: 20px"
                        >
                          <li>
                            <i
                              @click="showSubCategories($event, option._id, i)"
                              :class="
                                option.displaySubCategories
                                  ? 'fas fa-caret-down'
                                  : 'fas fa-caret-right'
                              "
                            />
                            <input
                              @click="handleCategoryClick($event, option._id)"
                              style="zoom: 1.4"
                              type="checkbox"
                              :value="option._id"
                              :id="`${indexAnswer}-${i}`"
                              :name="`${indexAnswer}-${i}`"
                              :checked="
                                allAnswers.answers[indexAnswer].categories
                                  .length > 0 &&
                                allAnswers.answers[
                                  indexAnswer
                                ].categories.findIndex(
                                  (el) => el === option._id,
                                ) >= 0
                              "
                            />
                            {{ option.name }}
                            <ul
                              v-if="!loading && option.displaySubCategories"
                              :id="`${option._id}`"
                              style="display: block; list-style: none"
                            >
                              <li
                                v-for="(subcategory, index) in categoriesList[i]
                                  .subCategories"
                                :key="index"
                              >
                                <input
                                  @click="
                                    handleSubCategoryClick(
                                      $event,
                                      option._id,
                                      subcategory._id,
                                    )
                                  "
                                  type="checkbox"
                                  style="zoom: 1.4"
                                  :value="subcategory._id"
                                  :id="`${indexAnswer}-${index}`"
                                  :name="`${indexAnswer}-${index}`"
                                  :checked="
                                    allAnswers.answers[indexAnswer]
                                      .subCategories.length > 0 &&
                                    allAnswers.answers[
                                      indexAnswer
                                    ].subCategories.findIndex(
                                      (el) => el === subcategory._id,
                                    ) >= 0
                                  "
                                />
                                {{ subcategory.name }}
                              </li>
                            </ul>
                          </li>
                        </ul></b-dropdown-text
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="position">
              <img
                id="arrow-right"
                style="cursor: pointer"
                @click="afterAnswer(allAnswers.answers[indexAnswer]._id)"
                src="../../../assets/polygon-right.png"
              />
            </div>
          </div>
        </div>

        <div class="col-12 main-buttons">
          <button id="button-categ-after" @click="afterAnswer(allAnswers.answers[indexAnswer]._id)">
            {{ $t('answers.nextAnswer') }}
          </button>
          <button
            id="button-categ-before"
            :disabled="indexAnswer === 0 ? true : false"
            @click="beforeAnswer"
          >
            {{ $t('answers.previousAnswer') }}
          </button>
        </div>
      </div>
      <div v-else>
        <template v-if="this.$store.state.treatments.loading">
          <p class="mt-4">
            <b-spinner
              variant="success"
              type="grow"
              label="Spinning"
              class="bg-primary"
            ></b-spinner>
          </p>
        </template>

        <p class="mt-3" v-if="!this.$store.state.treatments.loading">
          Sem dados para exibir
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert';
import Paginate from 'vuejs-paginate';
import { mapState, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { lightFormat } from 'date-fns';
import modalAddquestions from '@/components/molecules/modal-addquestions';
import api from '../../../services/api';
import idxChips from '../../molecules/idx-chips';
import dropdownCategories from '../../molecules/dropdown-categories';
import dropdownStatus from '../../molecules/dropdown-status';
import dashboardBar from '../../molecules/dashboard-bar';
import EventBus from '../../../eventBus';

export default {
  components: {
    idxChips,
    dropdownCategories,
    modalAddquestions,
    dropdownStatus,
    Paginate,
    dashboardBar,
  },

  data: () => ({
    displayFilterOptions: false,
    filterOptions: [
      { value: null, text: 'Escolha o filtro' },
      { value: 'profile', text: 'Perfil' },
      { value: 'status', text: 'Status' },
      { value: 'category', text: 'Categoria' },
      { value: 'responsible', text: 'Responsável' },
      { value: 'notification', text: 'Notificação' },
      { value: 'comemnt', text: 'Comentário' },
      { value: 'anonymous', text: 'Anônimo' },
      { value: 'treatmentTags', text: 'Tags Tratativas' },
    ],
    filterSelectedOptions: [],
    filterSelected: null,
    filterValueSelected: null,
    statusSelect: { value: null, text: null },
    profileSelect: { value: null, text: null },
    categorySelected: { value: null, text: null },
    responsibleSelected: { value: null, text: null },
    notificationSelected: { value: null, text: null },
    subTagSelected: { value: null, text: null },
    profileOptions: [],
    statusOptions: [],
    categoryOptions: [],
    responsibleOptions: [],
    tagOptions: [],
    userAuth: null,
    active: false,
    options: [],
    fields: [],
    filter: null,
    typingTimer: null,
    sortBy: null,
    sortDesc: null,
    grade: null,
    turnOffTheLight: false,
    commentEdited: null,
    loadingDownloadIconXls: false,
    loadingDownloadIconCsv: false,
    isGolCompany: false,
    actionCategories: [],
    filterSubCategorySelected: null,
    filterSubTagSelected: null,
    filterOptionsTag: [],
    filterOptionsSubCategory: [],
    filterOptionsSubTag: [],
    subCategoryOptions: [],
    subTagOptions: [],
    subCategorySelected: { value: null, text: null },
    channelSelected: { value: null, text: null },
    channelOptions: [],
    commentOptions: [],
    anonymousOptions: [],
    commentSelected: { value: null, text: null },
    anonymousSelected: { value: null, text: null },
    tagSelected: { value: null, text: null },
    categorySearch: '',
    listCategories: [],
    loading: false,
    selectComments: null,
    allAnswers: [],
    indexAnswer: 0,
    disabledBefore: false,
    disabledAfter: false,
    answerCategoryGroup: null,
  }),

  computed: {
    ...mapState('treatments', ['answer']),
    ...mapState('settings', ['companyCategories']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('branches', [
      'myIh1',
      'myIh2',
      'myHierarchies1',
      'myHierarchies2',
    ]),
    ...mapState('authentication', ['userProfile']),
    ...mapFields('treatments', ['page', 'fromDetails']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),

    categoriesList() {
      return this.listCategories.filter((option) => {
        return option.name
          .toLowerCase()
          .includes(this.categorySearch.toLowerCase());
      });
    },
  },

  methods: {
    ...mapActions('treatments', ['deleteCategory']),

    checkName(anonymous, name) {
      if (
        anonymous &&
        !this.userProfile.permissions.answers.anonymous_profile
      ) {
        return 'Anônimo';
      } else if (this.userProfile.permissions.answers.anonymous_profile) {
        return 'Nome: ***************';
      } else if (name) {
        return name;
      }
      return 'Sem Nome';
    },

    checkUserData(anonymous, profile, value) {
      if (anonymous || profile) {
        return '***************';
      } else if (value) {
        return value;
      }
      return '-';
    },

    async removeFilter(filter) {
      switch (filter) {
        case 'category':
          this.categorySelected.value = null;
          this.categorySelected.text = null;
          break;
        case 'subCategory':
          this.subCategorySelected.value = null;
          this.subCategorySelected.text = null;
          break;
        case 'status':
          this.statusSelect.value = null;
          this.statusSelect.text = null;
          break;
        case 'profile':
          this.profileSelect.value = null;
          this.profileSelect.text = null;
          break;
        case 'responsible':
          this.responsibleSelected.value = null;
          this.responsibleSelected.text = null;
          break;
        case 'notification':
          this.notificationSelected.value = null;
          this.notificationSelected.text = null;
          break;
        case 'channel':
          this.channelSelected.value = null;
          this.channelSelected.text = null;
          break;
        case 'comment':
          this.commentSelected.value = null;
          this.commentSelected.text = null;
          break;
        case 'anonymous':
          this.anonymousSelected.value = null;
          this.anonymousSelected.text = null;
          break;
        case 'tag':
          this.tagSelected.value = null;
          this.tagSelected.text = null;
          break;
        case 'subTag':
          this.subTagSelected.value = null;
          this.subTagSelected.text = null;
          break;
        default:
          break;
      }

      this.replaceQueryParams({ [filter]: undefined });

      await this.getListAnswers();
    },

    async afterAnswer(answerId) {
      if (this.indexAnswer < this.allAnswers.answers.length - 1) {
        this.indexAnswer = this.indexAnswer + 1;

        this.answerCategoryGroup = this.allAnswers.answers[this.indexAnswer]
          ? this.allAnswers.answers[this.indexAnswer].actionId.categoryGroupId
          : '';

        this.changeColorButton();
        this.scrollToTop();
        this.categorySearch = '';
      } else {
        swal({
          title: 'Última pergunta desta resposta',
          text: 'Você chegou na ultima pergunta do tipo INPUT desta resposta. Deseja ir para a proxima resposta?',
          icon: 'warning',
          buttons: [this.$t('answers.cancel'), 'Continuar'],
          warningMode: true,
        }).then(async (yes) => {
          if (yes) {
            await api.patch(
              `/update-answer/gol/${answerId}`,
              {},
              {
                headers: {
                  'x-access-token': this.userAuth.token,
                },
              },
            );
            this.getListAnswers();
          }
        });
      }
    },

    beforeAnswer() {
      this.indexAnswer = this.indexAnswer - 1;
      this.answerCategoryGroup = this.allAnswers.answers[this.indexAnswer]
        ? this.allAnswers.answers[this.indexAnswer].actionId.categoryGroupId
        : '';

      this.changeColorButton();
      this.scrollToTop();
      this.categorySearch = '';
    },

    scrollToTop() {
      const divCategory = document.getElementById('category');

      divCategory.scrollTop = 0;
    },

    changeColorButton() {
      if (this.indexAnswer === this.allAnswers.answers.length - 1) {
        document.getElementById('button-categ-after').style.background =
          '#4ce595';
        document.getElementById('button-categ-after').style.color = '#fff';
        document.getElementById('button-categ-after').style.border =
          'solid 1px #4ce595';
      } else if (this.indexAnswer === 0) {
        document.getElementById('button-categ-before').style.background =
          '#F0F6FB';
        document.getElementById('button-categ-before').style.border =
          'solid 1px #ADB5BD';
        document.getElementById('button-categ-before').style.color = '#ADB5BD';
      } else {
        document.getElementById('button-categ-before').style.background =
          '#4ce595';
        document.getElementById('button-categ-before').style.color = '#fff';
        document.getElementById('button-categ-before').style.border =
          'solid 1px #4ce595';

        document.getElementById('button-categ-after').style.background =
          '#4ce595';
        document.getElementById('button-categ-after').style.color = '#fff';
        document.getElementById('button-categ-after').style.border =
          'solid 1px #4ce595';
      }
    },

    async handleSubCategoryClick(event, categoryId, subCategoryId) {
      let operation = null;

      const categoryIndex = this.listCategories.findIndex(
        (el) => el._id === categoryId,
      );

      const category = this.listCategories[categoryIndex];

      const subCategoryIndex = category.subCategories.findIndex(
        (el) => el._id === subCategoryId,
      );

      const subCategory = category.subCategories[subCategoryIndex];

      if (event.target.checked === true) {
        operation = 'add';
      } else {
        operation = 'delete';
      }

      if (event.target.checked === true) {
        const index = this.allAnswers.answers[
          this.indexAnswer
        ].categories.findIndex((el) => el._id === category._id);
        if (index < 0) {
          if (
            !this.allAnswers.answers[this.indexAnswer].categories.includes(
              category._id,
            )
          ) {
            this.allAnswers.answers[this.indexAnswer].categories.push(
              category._id,
            );
          }
        }
        this.allAnswers.answers[this.indexAnswer].subCategories.push(
          subCategory._id,
        );
      } else {
        const index = this.allAnswers.answers[
          this.indexAnswer
        ].subCategories.findIndex((el) => el._id === subCategory._id);
        if (index >= 0) {
          this.allAnswers.answers[this.indexAnswer].subCategories.splice(
            index,
            1,
          );
        }
      }

      await api.patch(
        `/category-subcategory/gol/${
          this.allAnswers.answers[this.indexAnswer]._id
        }`,
        {
          subCategoryId: subCategory._id,
          categoryId: category._id,
          operation,
          questionId: this.allAnswers.answers[this.indexAnswer].questionId,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );
    },

    async handleCategoryClick(event, categoryId) {
      const categoryIndex = this.listCategories.findIndex(
        (el) => el._id === categoryId,
      );

      const category = this.listCategories[categoryIndex];

      if (event.target.checked === true) {
        if (
          !this.allAnswers.answers[this.indexAnswer].categories.includes(
            categoryId,
          )
        ) {
          this.allAnswers.answers[this.indexAnswer].categories.push(categoryId);
        }

        await api.patch(
          `/answer-categories/gol/${
            this.allAnswers.answers[this.indexAnswer]._id
          }`,
          {
            operation: 'add',
            categoryId: event.target.value,
            questionId: this.allAnswers.answers[this.indexAnswer].questionId,
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );
      } else {
        const foundIndex = this.allAnswers.answers[
          this.indexAnswer
        ].categories.findIndex((el) => el === category._id);

        if (foundIndex >= 0) {
          this.allAnswers.answers[this.indexAnswer].categories.splice(
            foundIndex,
            1,
          );
        }

        const response = await api.patch(
          `/answer-categories/gol/${
            this.allAnswers.answers[this.indexAnswer]._id
          }`,
          {
            operation: 'delete',
            categoryId: event.target.value,
            questionId: this.allAnswers.answers[this.indexAnswer].questionId,
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );

        this.allAnswers.answers[this.indexAnswer].subCategories =
          response.data.subCategories;
      }
    },

    async showSubCategories(event, categoryId, categoriesListIndex) {
      this.categoriesList[categoriesListIndex].displaySubCategories =
        !this.categoriesList[categoriesListIndex].displaySubCategories;

      if (this.categoriesList[categoriesListIndex].displaySubCategories) {
        event.target.classList.remove('fa-caret-right');
        event.target.classList.add('fa-caret-down');
      } else {
        event.target.classList.remove('fa-caret-down');
        event.target.classList.add('fa-caret-right');
      }

      this.loading = true;

      const response = await api.get(`/subcategories/${categoryId}`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });

      this.categoriesList[categoriesListIndex].subCategories = response.data;

      this.loading = false;
    },

    async getActionCategories() {
      if (this.answerCategoryGroup) {
        try {
          const response = await api.get('/categories-dropdown', {
            headers: {
              'x-access-token': this.userAuth.token,
            },
            params: {
              categoryGroup: this.answerCategoryGroup,
            },
          });

          // this.actionCategories = response.data;
          this.listCategories = response.data;

          this.listCategories.forEach((element) => {
            element.displaySubCategories = false;
            element.subCategories = [];
            element.loading = false;
          });
        } catch (error) {
          window.console.log(error);
        }
      }
    },

    async handleFilterSubCategory() {
      const index = this.filterOptionsSubCategory.findIndex(
        (el) => el.value === this.filterSubCategorySelected,
      );

      const text = this.filterOptionsSubCategory[index].text;
      const value = this.filterOptionsSubCategory[index].value;

      this.subCategorySelected.text = text;
      this.subCategorySelected.value = value;

      await this.getListAnswers();
    },

    async handleFilterSubTag() {
      const index = this.filterOptionsSubTag.findIndex(
        (el) => el.value === this.filterSubTagSelected,
      );

      const text = this.filterOptionsSubTag[index].text;
      const value = this.filterOptionsSubTag[index].value;

      this.subTagSelected.text = text;
      this.subTagSelected.value = value;

      await this.getListAnswers();
    },

    async getSubCategory(value) {
      this.subCategoryOptions = [
        {
          value: null,
          text: 'Selecione uma subcategoria',
        },
      ];

      const response = await api.get('/answer/categories-subcategories', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          idCategory: value,
        },
      });

      response.data.forEach((el) => {
        this.subCategoryOptions.push({
          value: el._id.toString(),
          text: el.name,
          categoryGroupId: el.categoryGroupId,
        });
      });

      this.filterOptionsSubCategory = this.subCategoryOptions;
    },

    async getListAnswers() {
      this.$store.state.treatments.loading = true;

      this.indexAnswer = 0;

      const response = await api.get('answer/categorizations-gol', {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          companyId: this.userAuth.companyId,
          actionId:
            this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          filter: this.filter,
          ih1:
            this.myHierarchies1.length === 0
              ? null
              : this.myHierarchies1.join(','),
          ih2:
            this.myHierarchies2.length === 0
              ? null
              : this.myHierarchies2.join(','),
          sortBy: this.sortBy,
          sortDesc: this.sortDesc,
          selectComments: this.selectComments,
          grade: this.grade,
          metric: this.myMetric,
          profile: this.profileSelect.value,
          status: this.statusSelect.value,
          groupId: this.actionGroupData._id,
          category: this.categorySelected.value,
          subCategory: this.subCategorySelected.value,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          responsible: this.responsibleSelected.value,
          notification: this.notificationSelected.value,
          channel: this.channelSelected.value,
          comment: this.commentSelected.value,
          anonymous: this.anonymousSelected.value,
          tag: this.tagSelected.value,
          subTag: this.subTagSelected.value,
          userId: this.userAuth._id,
        },
      });

      this.allAnswers = response.data;

      this.answerCategoryGroup = this.allAnswers.answers[0]
        ? this.allAnswers.answers[0].actionId.categoryGroupId
        : '';

      await this.getActionCategories();

      this.$store.state.treatments.loading = false;
    },

    async getTags() {
      this.tagOptions = [
        {
          value: null,
          text: 'Selecione uma tag',
        },
      ];

      const response = await api.get('/answer/tags', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });

      response.data.forEach((el) => {
        this.tagOptions.push({
          value: el._id.toString(),
          text: el.name,
        });
      });

      this.filterOptionsTag = this.tagOptions;
    },

    async getSubTags(value) {
      this.subTagOptions = [
        {
          value: null,
          text: 'Selecione uma subtag',
        },
      ];

      const response = await api.get('/answer/tags-subtags', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          idTag: value,
        },
      });

      response.data.forEach((el) => {
        this.subTagOptions.push({
          value: el._id.toString(),
          text: el.name,
          tagGroupId: el.tagGroupId,
        });
      });

      this.filterOptionsSubTag = this.subTagOptions;
    },

    async handleFilter() {
      this.filterValueSelected = null;
      this.filterSelectedOptions = [];

      if (this.filterSelected) {
        switch (this.filterSelected) {
          case 'category':
            if (this.myActionsIds.length > 0 && this.actionGroupData._id) {
              this.getCategoryGroupAction(
                this.myActionsIds,
                this.actionGroupData._id,
              );
            } else if (this.myActionsIds.length > 0) {
              this.getCategoryGroupAction(this.myActionsIds, null);
            } else if (this.actionGroupData._id) {
              this.getCategoryGroupAction(null, this.actionGroupData._id);
            } else {
              this.filterSelectedOptions = this.categoryOptions;
            }
            break;
          case 'status':
            this.filterSelectedOptions = this.statusOptions;
            break;
          case 'profile':
            this.filterSelectedOptions = this.profileOptions;
            break;
          case 'responsible':
            this.filterSelectedOptions = this.responsibleOptions;
            break;
          case 'notification':
            this.filterSelectedOptions = this.notificationOptions;
            break;
          case 'channel':
            this.filterSelectedOptions = this.channelOptions;
            break;
          case 'comment':
            this.filterSelectedOptions = this.commentOptions;
            break;
          case 'anonymous':
            this.filterSelectedOptions = this.anonymousOptions;
            break;
          case 'treatmentTags':
            this.filterSelectedOptions = this.tagOptions;
            break;
          default:
            break;
        }

        this.displayFilterOptions = true;
      } else {
        this.displayFilterOptions = false;
      }
    },

    async handleFilterValue() {
      if (this.filterSelected && this.filterValueSelected) {
        const index = this.filterSelectedOptions.findIndex(
          (el) => el.value === this.filterValueSelected,
        );

        const text = this.filterSelectedOptions[index].text;

        switch (this.filterSelected) {
          case 'category':
            this.categorySelected.value = this.filterValueSelected;
            this.categorySelected.text = text;

            this.getSubCategory(this.filterValueSelected);
            break;
          case 'status':
            this.statusSelect.value = this.filterValueSelected;
            this.statusSelect.text = text;
            break;
          case 'profile':
            this.profileSelect.value = this.filterValueSelected;
            this.profileSelect.text = text;
            break;
          case 'responsible':
            this.responsibleSelected.value = this.filterValueSelected;
            this.responsibleSelected.text = text;
            break;
          case 'notification':
            this.notificationSelected.value = this.filterValueSelected;
            this.notificationSelected.text = text;
            break;
          case 'channel':
            this.channelSelected.value = this.filterValueSelected;
            this.channelSelected.text = text;
            break;
          case 'comment':
            this.commentSelected.value = this.filterValueSelected;
            this.commentSelected.text = text;
            break;
          case 'anonymous':
            this.anonymousSelected.value = this.filterValueSelected;
            this.anonymousSelected.text = text;
            break;
          case 'treatmentTags':
            this.tagSelected.value = this.filterValueSelected;
            this.tagSelected.text = text;

            this.getSubTags(this.filterValueSelected);
            break;
          default:
            break;
        }

        this.replaceQueryParams({
          [this.filterSelected]: this.filterValueSelected,
        });

        await this.getListAnswers();
      }
    },

    async handleJustComments(checked) {
      this.selectComments = checked;
      this.replaceQueryParams({ just_comments: checked ? true : false });
      await this.getListAnswers();
    },

    replaceQueryParams(object) {
      this.$router.replace({
        path: this.$route.path,
        query: { ...this.$route.query, ...object },
      });
    },

    searchByFilter() {
      if (this.filter !== '' && this.filter !== null) {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.getListAnswers(), 600);
      }
      if (this.filter === '') {
        this.filter = null;
        this.this.getListAnswers();
      }
    },

    cleanFilter() {
      this.filter = null;
      this.getListAnswers();
    },

    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getListAnswers();
    },

    dateFormat(param) {
      const day = lightFormat(new Date(param), 'dd/MM/yyyy');
      const hour = lightFormat(new Date(param), 'HH:mm');
      return `${day} às ${hour}`;
    },

    gradeFormat(grade) {
      const metric = this.allAnswers.answers[this.indexAnswer].metric;

      if (metric === 'nps-0-10') {
        if (grade >= 9 && grade <= 10) {
          return 'promoters';
        } else if (grade === 7 || grade === 8) {
          return 'neutral';
        } else if (grade < 7) {
          return 'detractors';
        }
        return 'invalid';
      } else if (metric === 'like-dislike') {
        if (grade === 1) {
          return 'promoters';
        } else if (grade === 0) {
          return 'detractors';
        }
        return 'invalid';
      } else if (
        metric === 'nps-1-5' ||
        metric === 'ces-1-5' ||
        metric === 'csat-1-5' ||
        metric === 'csat-1-5(media)' ||
        metric === '5-stars'
      ) {
        if (grade > 3 && grade < 6) {
          return 'promoters';
        } else if (grade === 3) {
          return 'neutral';
        } else if (grade < 3) {
          return 'detractors';
        }
        return 'invalid';
      }
      return 'invalid';
    },

    async getCompanyCategories() {
      try {
        const response = await api.get('/categories', {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            categoryGroup: null,
          },
        });
        this.actionCategories = response.data;
      } catch (error) {
        window.console.log(error);
      }
    },

    getCategoryName(id) {
      for (let i = 0; i < this.actionCategories.length; i += 1) {
        if (id === this.actionCategories[i]._id) {
          return this.actionCategories[i].name;
        }
      }
      return '';
    },

    async removeCategorySubCategory(event, answer, categoryId, subCategoryId) {
      let operation = null;
      answer.categories.splice(answer.categories.indexOf(categoryId), 1);

      if (event.target.checked === true) {
        operation = 'add';
      } else {
        operation = 'delete';
      }

      await api.patch(
        `/category-subcategory/gol/${answer._id}`,
        {
          subCategoryId,
          categoryId,
          operation,
          questionId: this.allAnswers.answers[this.indexAnswer].questionId,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );
    },

    async deleteCategoryByX(answer, categoryId) {
      answer.categories.splice(answer.categories.indexOf(categoryId), 1);

      try {
        await api.patch(
          `/answer-categories/gol/${answer._id}`,
          {
            operation: 'delete',
            categoryId,
            questionId: this.allAnswers.answers[this.indexAnswer].questionId,
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );
      } catch (error) {
        window.console.log(error);
      }
    },

    hideMenu() {
      this.turnOffTheLight = false;
    },

    async getStatus() {
      const response = await api.get(`treatments-status`, {
        headers: { 'x-access-token': this.userAuth.token },
      });

      response.data.forEach((el) => {
        this.statusOptions.push({ value: el.value, text: el.text });
      });
    },

    async getResponsibles() {
      const response = await api.get('treatments/responsible-users', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          ih1:
            this.myHierarchies1.length === 0
              ? null
              : this.myHierarchies1.join(','),
          ih2:
            this.myHierarchies2.length === 0
              ? null
              : this.myHierarchies2.join(','),
        },
      });

      const users = response.data;

      users.forEach((el) =>
        this.responsibleOptions.push({ value: el._id, text: el.name }),
      );
    },

    async handleRemoveCategory(answerIndex, categoryId, categoryIndex) {
      swal({
        title: this.$t('answers.deleteCategory.title'),
        text: this.$t('answers.deleteCategory.description'),
        icon: 'warning',
        buttons: [this.$t('answers.cancel'), this.$t('answers.remove')],
        dangerMode: true,
      }).then(async (deleted) => {
        if (deleted) {
          swal(this.$t('answers.categoryDelSuccess'), {
            icon: 'success',
          });
          this.answer[answerIndex].categories.splice(categoryIndex, 1);
          const subCategories = [];
          this.answer[answerIndex].subCategories.forEach((el) => {
            if (el.mainCategoryId !== categoryId) {
              subCategories.push(el);
            }
          });
          this.answer[answerIndex].subCategories = subCategories;
          await api.patch(
            `/answer-categories/gol/${this.answer[answerIndex]._id}`,
            {
              operation: 'delete',
              categoryId,
              questionId: this.allAnswers.answers[this.indexAnswer].questionId,
            },
            {
              headers: {
                'x-access-token': this.userAuth.token,
              },
            },
          );
        }
      });
    },

    isCategoryIA(answerIndex, id) {
      if (this.answer[answerIndex].categoriesIA) {
        for (
          let i = 0;
          i < this.answer[answerIndex].categoriesIA.length;
          i += 1
        ) {
          if (id === this.answer[answerIndex].categoriesIA[i]) {
            return true;
          }
        }
      }
      return false;
    },

    isSubCategoryIA(answerIndex, id) {
      if (this.answer[answerIndex].subCategoriesIA) {
        for (
          let i = 0;
          i < this.answer[answerIndex].subCategoriesIA.length;
          i += 1
        ) {
          if (id === this.answer[answerIndex].subCategoriesIA[i]) {
            return true;
          }
        }
      }
      return false;
    },

    async handleRemoveSubCategory(
      answerIndex,
      categoryId,
      subCategoryId,
      subCategoryIndex,
    ) {
      this.answer[answerIndex].subCategories.splice(subCategoryIndex, 1);

      await api.patch(
        `/category-subcategory/gol/${this.answer[answerIndex]._id}`,
        {
          subCategoryId,
          categoryId,
          operation: 'delete',
          questionId: this.allAnswers.answers[this.indexAnswer].questionId,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );
    },

    async getCategoryGroupAction(actionId, actionGroupId) {
      try {
        const response = await api.get('/categories-groups', {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            actionId,
            actionGroupId,
          },
        });

        const categoriesGroups = response.data;

        this.filterSelectedOptions = [
          { value: null, text: this.$t('answers.categorySelect.select') },
          { value: 'all', text: this.$t('answers.categorySelect.all') },
          { value: 'empty', text: this.$t('answers.categorySelect.empty') },
        ];

        categoriesGroups.categories.forEach((el) => {
          if (el.active === true) {
            this.filterSelectedOptions.push({
              value: el._id.toString(),
              text: el.name,
            });
          }
        });
      } catch (error) {
        window.console.log(error);
      }
    },
    showComment(comment) {
      if (comment && comment.length > 255) {
        return `${comment.substr(0, 255)} ...`;
      }
      return comment;
    },
    showDays(item) {
      // If there is no starDate, we don't have howe to calculate solving period
      if (!item.treatments.startDate) {
        return 'N/A';
      }
      const startDate = new Date(item.treatments.startDate);
      let solvedDate;
      // If there is no solvedDate, calculates with current time
      if (item.treatments.solvedDate) {
        solvedDate = new Date(item.treatments.solvedDate);
      } else {
        solvedDate = new Date();
      }
      // If period < 1 day, returns period in time
      const diffTime = solvedDate - startDate;
      const diffDays = Math.floor(diffTime / (1000 * 3600 * 24));
      if (diffDays > 0) {
        return `${diffDays} d`;
      }
      return `${new Date(diffTime).toISOString().substr(11, 2)} h`;
    },

    changeLabels() {
      this.filterOptions = [
        { value: null, text: this.$t('answers.filterOptions.select') },
        { value: 'profile', text: this.$t('answers.filterOptions.profile') },
        { value: 'status', text: this.$t('answers.filterOptions.status') },
        { value: 'category', text: this.$t('answers.filterOptions.category') },
        {
          value: 'responsible',
          text: this.$t('answers.filterOptions.responsible'),
        },
        {
          value: 'notification',
          text: this.$t('answers.filterOptions.notification'),
        },
        {
          value: 'channel',
          text: this.$t('answers.filterOptions.channel'),
        },
        {
          value: 'comment',
          text: this.$t('answers.filterOptions.comments'),
        },
        {
          value: 'anonymous',
          text: this.$t('answers.filterOptions.anonymous'),
        },
        {
          value: 'treatmentTags',
          text: this.$t('answers.filterOptions.treatmentTags'),
        },
      ];

      let promotersText = '';
      let passivesText = '';
      let detractorsText = '';

      if (this.myMetric.indexOf('nps') >= 0) {
        promotersText = this.$t('answers.profileSelect.promoters');
        passivesText = this.$t('answers.profileSelect.neutral');
        detractorsText = this.$t('answers.profileSelect.detractors');
      } else if (this.myMetric.indexOf('ces') >= 0) {
        promotersText = '5-4';
        passivesText = '3';
        detractorsText = '2-1';
      } else if (this.myMetric.indexOf('csat') >= 0) {
        promotersText = '5-4';
        passivesText = '3';
        detractorsText = '2-1';
      } else if (this.myMetric.indexOf('stars') >= 0) {
        promotersText = '5-4';
        passivesText = '3';
        detractorsText = '2-1';
      } else if (this.myMetric.indexOf('like-dislike') >= 0) {
        promotersText = 'Like';
        detractorsText = 'Dislike';
      }

      if (this.myMetric === 'like-dislike') {
        this.profileOptions = [
          { value: null, text: this.$t('answers.profileSelect.select') },
          { value: 'all', text: this.$t('answers.profileSelect.all') },
          { value: 'detractors', text: detractorsText },
          { value: 'promoters', text: promotersText },
        ];
      } else {
        this.profileOptions = [
          { value: null, text: this.$t('answers.profileSelect.select') },
          { value: 'all', text: this.$t('answers.profileSelect.all') },
          { value: 'detractors', text: detractorsText },
          { value: 'passives', text: passivesText },
          { value: 'promoters', text: promotersText },
        ];
      }

      this.categoryOptions = [
        { value: null, text: this.$t('answers.categorySelect.select') },
        { value: 'all', text: this.$t('answers.categorySelect.all') },
        { value: 'empty', text: this.$t('answers.categorySelect.empty') },
      ];

      this.subCategoryOptions = [
        {
          value: null,
          text: 'Selecione uma subcategoria',
        },
      ];

      this.tagOptions = [{ value: null, text: 'Selecione a tag' }];

      this.subTagOptions = [
        {
          value: null,
          text: 'Selecione uma subtag',
        },
      ];

      this.getStatus();

      this.responsibleOptions = [
        { value: null, text: this.$t('answers.responsibleSelect') },
      ];

      this.notificationOptions = [
        { value: null, text: this.$t('answers.notificationSelect') },
        {
          value: 'noviewed',
          text: this.$t('answers.notificationSelects.noViewed'),
        },
        {
          value: 'viewed',
          text: this.$t('answers.notificationSelects.viewed'),
        },
      ];

      this.channelOptions = [
        { value: null, text: this.$t('answers.channelSelect.select') },
        { value: 'all', text: this.$t('answers.channelSelect.all') },
        {
          value: 'email',
          text: this.$t('answers.channelSelect.email'),
        },
        {
          value: 'link',
          text: this.$t('answers.channelSelect.link'),
        },
        {
          value: 'manual',
          text: this.$t('answers.channelSelect.manual'),
        },
        {
          value: 'qrcode',
          text: this.$t('answers.channelSelect.qrcode'),
        },
        {
          value: 'sms',
          text: this.$t('answers.channelSelect.sms'),
        },
        {
          value: 'whatsapp',
          text: this.$t('answers.channelSelect.whatsapp'),
        },
        {
          value: 'widget',
          text: this.$t('answers.channelSelect.widget'),
        },
      ];

      this.commentOptions = [
        { value: null, text: this.$t('answers.commentsSelect.select') },
        { value: 'all', text: this.$t('answers.commentsSelect.all') },
        {
          value: 'withComments',
          text: this.$t('answers.commentsSelect.withComments'),
        },
        {
          value: 'noComments',
          text: this.$t('answers.commentsSelect.noComments'),
        },
      ];

      this.anonymousOptions = [
        { value: null, text: this.$t('answers.anonymousSelect.select') },
        { value: 'all', text: this.$t('answers.anonymousSelect.all') },
        {
          value: 'false',
          text: this.$t('answers.anonymousSelect.no'),
        },
        {
          value: 'true',
          text: this.$t('answers.anonymousSelect.yes'),
        },
      ];
    },
  },

  watch: {
    indexAnswer: function watchIndexAnswer() {
      this.changeColorButton();
    },

    actionGroupData: function watchActionGroup() {
      this.getListAnswers();
    },

    myActionId: function watchmyActionId() {
      this.getListAnswers();
    },

    myActionsIds: function watchmyActionsIds() {
      this.getListAnswers();
    },

    calendarDates: function watchCalendarDates() {
      this.getListAnswers();
    },

    myIh1: function watchMyIh1() {
      this.getListAnswers();
    },

    myHierarchies1: function watchMyHierarchies1() {
      this.getListAnswers();
    },

    myIh2: function watchMyIh2() {
      this.getListAnswers();
    },

    myHierarchies2: function watchMyHierarchies2() {
      this.getListAnswers();
    },

    myMetric: function watchMyMetric() {
      this.changeLabels();
      this.getListAnswers();
    },

    'indicatorData.value': function watchIndicatorDataValue() {
      this.getListAnswers();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      this.getListAnswers();
    },
  },

  mounted() {
    EventBus.$on('changedLanguage', () => {
      this.changeLabels();
    });
    EventBus.$on('changedAction', () => {
      this.handleFilter();
    });
    EventBus.$on('resetFilterCategory', () => {
      this.filterSelected = null;
      this.filterValueSelected = null;
      this.displayFilterOptions = false;
    });
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    // this.categorySelected.value = 'empty';
    // this.categorySelected.text = 'Sem categoria (vazio)';

    // this.replaceQueryParams({
    //   category: 'empty',
    // });

    await Promise.all([this.getCompanyCategories()], this.getResponsibles());

    this.changeLabels();

    this.getSubTags();
    this.getTags();

    this.actionCategories.forEach((el) => {
      if (el.active === true) {
        this.options.push(el);

        this.categoryOptions.push({
          value: el._id.toString(),
          text: el.name,
          categoryGroupId: el.categoryGroupId,
        });
      }
    });
    if (this.fromDetails) {
      this.fromDetails = false;
    } else {
      this.page = 1;
    }

    if (parseInt(this.$route.query.grade, 10) + 1) {
      this.grade = this.$route.query.grade;
    }

    if (this.$route.query.profile) {
      const index = this.profileOptions.findIndex(
        (el) => el.value === this.$route.query.profile,
      );

      if (index >= 0) {
        this.profileSelect.value = this.profileOptions[index].value;
        this.profileSelect.text = this.profileOptions[index].text;
      }
    }

    if (this.$route.query.category) {
      const index = this.categoryOptions.findIndex(
        (el) => el.value === this.$route.query.category,
      );

      if (index >= 0) {
        this.categorySelected.value = this.categoryOptions[index].value;
        this.categorySelected.text = this.categoryOptions[index].text;
      }
    }

    if (this.$route.query.status) {
      const index = this.statusOptions.findIndex(
        (el) => el.value === this.$route.query.status,
      );

      if (index >= 0) {
        this.statusSelect.value = this.statusOptions[index].value;
        this.statusSelect.text = this.statusOptions[index].text;
      }
    }

    if (this.$route.query.responsible) {
      const index = this.responsibleOptions.findIndex(
        (el) => el.value === this.$route.query.responsible,
      );

      if (index >= 0) {
        this.responsibleSelected.value = this.responsibleOptions[index].value;
        this.responsibleSelected.text = this.responsibleOptions[index].text;
      }
    }

    if (this.$route.query.notification) {
      const index = this.notificationOptions.findIndex(
        (el) => el.value === this.$route.query.notification,
      );

      if (index >= 0) {
        this.notificationSelected.value = this.notificationOptions[index].value;
        this.notificationSelected.text = this.notificationOptions[index].text;
      }
    }

    if (this.$route.query.channel) {
      const index = this.channelOptions.findIndex(
        (el) => el.value === this.$route.query.channel,
      );

      if (index >= 0) {
        this.channelSelected.value = this.channelOptions[index].value;
        this.channelSelected.text = this.channelOptions[index].text;
      }
    }
    if (this.$route.query.comment) {
      const index = this.commentOptions.findIndex(
        (el) => el.value === this.$route.query.comment,
      );

      if (index >= 0) {
        this.commentSelected.value = this.commentOptions[index].value;
        this.commentSelected.text = this.commentOptions[index].text;
      }
    }

    if (this.$route.query.just_comments) {
      this.selectComments = true;
    }

    await this.getListAnswers();
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.title-name {
  font-weight: 500;
  font-size: 18px;
  line-height: 18px;
}

.paragraph {
  line-height: 22px;
  margin-top: 20px;
}

.question {
  font-weight: 700;
}

center {
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
}

.position {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.content {
  width: 100%;
  padding: 24px 24px 24px 15px !important;
}

.content-question {
  padding: 10px;
  background: #f0f0f0;
  margin-right: 10px;
  margin-left: 10px;
  display: flex;
  height: 100%;
}

.feedback-info {
  height: 92%;
  width: 100%;
  background: #fff;
  border-radius: 4px;
  color: #5e5e5e;
  padding: 12px;
}

.info-question {
  padding: 20px;
  width: 100%;
}

.align-input {
  text-align: center;
  margin-top: 15px;
}

li {
  list-style: none;
}

.feedback-box {
  padding: 5px;
  min-height: 250px;
  max-height: 250px;
  overflow: auto;
}

.category-box {
  background: #ffffff;
  border-radius: 2px;
  min-height: 280px;
  max-height: 280px;
  overflow: auto;
}

.icon-eraser-category {
  margin-left: -5px;
  padding-right: 10px;
  padding-left: 10px;
  margin-bottom: 5px;
}

.input-search-categories {
  width: 70%;
  margin-top: 10px;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  margin-left: 20px;
}

.info-data-title {
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  margin-right: 15px;
}

.info-data {
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
}

.note {
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  color: #495057;
}

.title {
  font-weight: 600;
  font-size: 20px;
  line-height: 18px;
  color: #242424;
}

.flag-grade {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: $white;
  font-weight: bold;
}

.flag-grade-promoters {
  background-color: #28a745;
}

.flag-grade-detractors {
  background-color: #dc3545;
}

.flag-grade-neutral {
  background-color: rgb(211, 211, 17);
}

.flag-grade-invalid {
  background-color: #c1c1c1;
}

.flag-sentiment {
  padding: 15px;
  font-size: 20px;
}

.flag-sentiment-negative {
  color: #dc3545;
}

.flag-sentiment-neutral {
  color: rgb(211, 211, 17);
}

.flag-sentiment-positive {
  color: #28a745;
}

.sentimentScore {
  font-size: 28px;
}

.line {
  border-right: 1px solid #cccccc;
  margin-right: 5px;
  margin-left: 5px;
  margin-top: 58px;
  margin-bottom: 32px;
}

.main-buttons {
  text-align: right;
  margin-top: 20px;
}

#button-categ-after {
  background: #4ce595;
  color: #fff;
  border: none;
  padding: 10px;
  border-radius: 4px;
  float: right;
  margin: 10px;
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  height: 42px;
}

#button-categ-before {
  background: #f0f6fb;
  color: #adb5bd;
  border: #adb5bd solid 1px;
  padding: 10px;
  border-radius: 4px;
  float: right;
  margin: 10px;
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  height: 42px;
}

.header-filters {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .search-answers {
    display: flex;
    flex-direction: row;
    width: 350px;

    input {
      border-bottom-right-radius: 0;
      border-top-right-radius: 0;
    }

    button {
      height: 38px;
      border-bottom-left-radius: 0;
      border-top-left-radius: 0;
    }
  }
}

.filters-options-area {
  display: flex;
  flex-direction: row;
}

.categories-area {
  max-height: 150px;
  overflow: auto;
}

.switch-box {
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.switch-box span {
  font-size: 16px;
}

.filters-area {
  display: flex;
  flex-direction: row;

  .tag {
    background: $primary;
    padding: 4px 8px;
    color: $white;
    border-radius: 8px;
    margin-right: 8px;

    .remove {
      cursor: pointer;
    }
  }
}

.wrapper {
  padding: 8px;
}

.wrapp {
  background-color: $white;
  padding: 16px;
  border: 1px solid $gray-light;
  border-radius: 4px;
}

.wrapp h2 {
  text-transform: uppercase;
  font-size: 21px;
  font-weight: 100;
  color: $gray;
}

.header-icon {
  float: left;
  font-size: 12px;
  margin-top: 4px;
  padding-right: 12px;
  color: $gray;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/categorization-additional/index.vue